export default function SessionsPage() {
  return (
    <div>
      <h1>Sessions</h1>
      <p>Hier findest du alle deine Trading Sessions.</p>
    </div>
  );
}
